export const WEGO_LOCALE_COOKIE_KEY = 'wego_locale';

export const WEGO_CURRENCY_COOKIE_KEY = 'wego_currency';

export const WEGO_PREFERRED_PAYMENT_METHODS_COOKIE_KEY = 'wego_preferred_payment_methods';
